"use client";

import React, { useContext } from "react";
import { Box, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MenuContext from "@/context/MenuProvider";
import "@/style/css/SideBar.css";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const menus = [
  {
    title: "FAQ",
    path: "/faq"
  },
  {
    title: "Kritik dan Saran",
    path: "/kritik-saran"
  },
  {
    title: "Denah",
    path: "/denah"
  }
];

export interface MenuProps {
  title: string;
  path?: string;
  anchor?: string;
}

interface SideDrawerProps {
  title: string;
  anchor: string;
  prevAnchor?: string;
  menus: MenuProps[];
}

export const SideDrawer = ({ title, anchor, prevAnchor, menus }: SideDrawerProps) => {
  const { state, setState } = useContext(MenuContext)!;

  const handleEvent = (callback) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    callback();
  };

  const toggleDrawer = (targetAnchor, open) => {
    setState({ ...state, [targetAnchor]: open });
  };

  const switchDrawer = (targetAnchor) => {
    setState({ ...state, [anchor]: false, [targetAnchor]: true });
  };

  // TODO cek apakah membuka link -> menutup drawer

  const list = () => (
    <Box sx={{ width: 250 }} role="presentation">
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {prevAnchor && <IconButton onClick={handleEvent(() => switchDrawer(prevAnchor))}>
          <KeyboardArrowLeftIcon/>
        </IconButton>}
        <Typography sx={{ textAlign: "center", paddingY: "10px", textTransform: "uppercase", flexGrow: 1 }}>
          {title}
        </Typography>
        <IconButton onClick={handleEvent(() => toggleDrawer(anchor, false))}>
          <CloseIcon/>
        </IconButton>
      </Box>
      <Divider/>
      <List>
        {menus.map((menu, key) => (
          <ListItem key={key} disablePadding>
            {menu.path &&
              <ListItemButton href={menu.path}>
                <ListItemText primary={menu.title}/>
              </ListItemButton>
            }
            {menu.anchor &&
              <ListItemButton onClick={handleEvent(() => switchDrawer(menu.anchor))}>
                <ListItemText primary={menu.title}/>
                <Stack>
                  <ArrowForwardIosIcon/>
                </Stack>
              </ListItemButton>
            }
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Drawer
      anchor={"left"}
      open={state[anchor]}
      onClose={handleEvent(() => toggleDrawer(anchor, false))}
    >
      {list()}
    </Drawer>
  );
};

